import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, AlignLeft, ArrowRight, Bell, BellOff, Bookmark, BookOpen, Calendar, Clock, Check, ChevronDown, ChevronLeft, Download, Eye, Filter, Flag, Globe, Heart, Home, Image as ImageIcon, Link as LinkIcon, Lock, Mail, Menu, MessageCircle, MessageSquare, MoreHorizontal, Network, Paperclip, Pencil, Pin, Plus, Search, Send, Settings, Share, Shield, Sparkles, Trash2, Upload, UserPlus, Users, Video, X, } from 'lucide-react';
import { Circles } from '../Icon/Circles';
const SIZE = '100%';
const STROKE = 1.75;
// Lucide v1 dropped every brand glyph (Twitter, Facebook, Instagram, LinkedIn).
// Keep the brand marks inline.
const XBrand = (_jsx("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "100%", height: "100%", children: _jsx("path", { d: "M17.7 3h3.1l-6.8 7.8L22 21h-6.3l-4.9-6.4L5.1 21H2l7.2-8.3L2 3h6.4l4.4 5.8zm-1.1 16h1.7L7.5 4.9H5.7z" }) }));
const Instagram = (_jsxs("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: STROKE, strokeLinecap: "round", strokeLinejoin: "round", width: "100%", height: "100%", children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5" }), _jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("circle", { cx: "17.5", cy: "6.5", r: ".9", fill: "currentColor", stroke: "none" })] }));
const Facebook = (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: STROKE, strokeLinecap: "round", strokeLinejoin: "round", width: "100%", height: "100%", children: _jsx("path", { d: "M14 8h2.5V5H14c-2 0-3.5 1.5-3.5 3.5V11H8v3h2.5v7h3v-7H16l.5-3h-3V8.5c0-.3.2-.5.5-.5z" }) }));
const Linkedin = (_jsxs("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: STROKE, strokeLinecap: "round", strokeLinejoin: "round", width: "100%", height: "100%", children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), _jsx("path", { d: "M7 10v7M7 7.5v.01M11 17v-7M11 13c0-1.7 1-3 2.5-3s2.5 1.3 2.5 3v4" })] }));
export const I = {
    home: _jsx(Home, { size: SIZE, strokeWidth: STROKE }),
    feed: _jsx(AlignLeft, { size: SIZE, strokeWidth: STROKE }),
    circles: _jsx(Circles, { size: SIZE, strokeWidth: STROKE }),
    network: _jsx(Network, { size: SIZE, strokeWidth: STROKE }),
    users: _jsx(Users, { size: SIZE, strokeWidth: STROKE }),
    userPlus: _jsx(UserPlus, { size: SIZE, strokeWidth: STROKE }),
    eye: _jsx(Eye, { size: SIZE, strokeWidth: STROKE }),
    clock: _jsx(Clock, { size: SIZE, strokeWidth: STROKE }),
    msg: _jsx(MessageSquare, { size: SIZE, strokeWidth: STROKE }),
    spark: _jsx(Sparkles, { size: SIZE, strokeWidth: STROKE }),
    cal: _jsx(Calendar, { size: SIZE, strokeWidth: STROKE }),
    book: _jsx(BookOpen, { size: SIZE, strokeWidth: STROKE }),
    bell: _jsx(Bell, { size: SIZE, strokeWidth: STROKE }),
    bellOff: _jsx(BellOff, { size: SIZE, strokeWidth: STROKE }),
    search: _jsx(Search, { size: SIZE, strokeWidth: STROKE }),
    plus: _jsx(Plus, { size: SIZE, strokeWidth: STROKE }),
    arrow: _jsx(ArrowRight, { size: SIZE, strokeWidth: STROKE }),
    heart: _jsx(Heart, { size: SIZE, strokeWidth: STROKE }),
    chat: _jsx(MessageCircle, { size: SIZE, strokeWidth: STROKE }),
    share: _jsx(Share, { size: SIZE, strokeWidth: STROKE }),
    bookmark: _jsx(Bookmark, { size: SIZE, strokeWidth: STROKE }),
    bookmarkFilled: _jsx(Bookmark, { size: SIZE, strokeWidth: STROKE, fill: "currentColor" }),
    lock: _jsx(Lock, { size: SIZE, strokeWidth: STROKE }),
    globe: _jsx(Globe, { size: SIZE, strokeWidth: STROKE }),
    shield: _jsx(Shield, { size: SIZE, strokeWidth: STROKE }),
    more: _jsx(MoreHorizontal, { size: SIZE, strokeWidth: STROKE }),
    check: _jsx(Check, { size: SIZE, strokeWidth: STROKE }),
    pin: _jsx(Pin, { size: SIZE, strokeWidth: STROKE }),
    pinFilled: _jsx(Pin, { size: SIZE, strokeWidth: STROKE, fill: "currentColor" }),
    filter: _jsx(Filter, { size: SIZE, strokeWidth: STROKE }),
    arrowDown: _jsx(ChevronDown, { size: SIZE, strokeWidth: STROKE }),
    menu: _jsx(Menu, { size: SIZE, strokeWidth: STROKE }),
    send: _jsx(Send, { size: SIZE, strokeWidth: STROKE }),
    attach: _jsx(Paperclip, { size: SIZE, strokeWidth: STROKE }),
    back: _jsx(ChevronLeft, { size: SIZE, strokeWidth: STROKE }),
    cog: _jsx(Settings, { size: SIZE, strokeWidth: STROKE }),
    flag: _jsx(Flag, { size: SIZE, strokeWidth: STROKE }),
    mail: _jsx(Mail, { size: SIZE, strokeWidth: STROKE }),
    edit: _jsx(Pencil, { size: SIZE, strokeWidth: STROKE }),
    trash: _jsx(Trash2, { size: SIZE, strokeWidth: STROKE }),
    upload: _jsx(Upload, { size: SIZE, strokeWidth: STROKE }),
    download: _jsx(Download, { size: SIZE, strokeWidth: STROKE }),
    x: _jsx(X, { size: SIZE, strokeWidth: STROKE }),
    alert: _jsx(AlertTriangle, { size: SIZE, strokeWidth: STROKE }),
    image: _jsx(ImageIcon, { size: SIZE, strokeWidth: STROKE }),
    video: _jsx(Video, { size: SIZE, strokeWidth: STROKE }),
    instagram: Instagram,
    facebook: Facebook,
    linkedin: Linkedin,
    link: _jsx(LinkIcon, { size: SIZE, strokeWidth: STROKE }),
    xBrand: XBrand,
};
const ICON_SIZE = { sm: 14, md: 18, lg: 24 };
export function Icon({ children, size = 'md', color, className, style, }) {
    const s = typeof size === 'string' ? ICON_SIZE[size] : size;
    return (_jsx("span", { className: className, style: {
            width: s,
            height: s,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            color,
            ...style,
        }, children: children }));
}
//# sourceMappingURL=icons.js.map